import React, { useState, useEffect } from "react";
import { withFirebase } from "../../firebase";
import Ingredients from "./Ingredients";
import { useParams } from "react-router-dom";

const Container = ({ firebase }) => {
	const [ingredients, setIngredients] = useState([]);

	const { brandId } = useParams();

	const getData = async () => {
		const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
		const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));

		const refPath = `${
			isDebug ? "debug" : ""
		}/settings/city/${currentCity}/brands/${currentBrand}/productFilters`;

		try {
			// Получаем данные productFilters
			const snapshot = await firebase.bd.ref(refPath).once("value");
			let productFilters = snapshot.val();

			if (!productFilters) {
				productFilters = { ingredients: [""] };
				await firebase.bd.ref(refPath).set(productFilters);
			} else {
				if (!productFilters.ingredients) {
					productFilters.ingredients = [""];
					await firebase.bd
						.ref(`${refPath}/ingredients`)
						.set(productFilters.ingredients);
				} else if (productFilters.ingredients.length === 0) {
					productFilters.ingredients.push("");
					await firebase.bd
						.ref(`${refPath}/ingredients`)
						.set(productFilters.ingredients);
				}
			}

			setIngredients(productFilters.ingredients);
		} catch (error) {
			console.error("Ошибка при получении данных:", error);
		}
	};

	const deleteIngredient = async (index) => {
		const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
		const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));

		const refPath = `${
			isDebug ? "debug" : ""
		}/settings/city/${currentCity}/brands/${currentBrand}/productFilters/ingredients`;

		let updatedIngredients = ingredients.filter((_, i) => i !== index);

		// Если удалили последний элемент, заменяем массив на [""]
		if (updatedIngredients.length === 0) {
			updatedIngredients = [""];
		}

		// Записываем обновленный массив в Firebase
		try {
			await firebase.bd.ref(refPath).set(updatedIngredients);
			setIngredients(updatedIngredients);
			console.log("Ингредиент удален");
		} catch (error) {
			console.error("Ошибка при удалении ингредиента:", error);
		}
	};

	const changeStatus = async (index) => {
		const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
		const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));

		const refPath = `${
			isDebug ? "debug" : ""
		}/settings/city/${currentCity}/brands/${currentBrand}/productFilters/ingredients`;

		const updatedIngredients = [...ingredients];
		const ingredient = updatedIngredients[index];
		if (ingredient) {
			ingredient.isActive = !ingredient.isActive; // Меняем статус
		}

		try {
			// Обновляем массив ингредиентов в Firebase
			await firebase.bd.ref(refPath).set(updatedIngredients);
			setIngredients(updatedIngredients); // Обновляем состояние компонента
			console.log("Статус ингредиента обновлен");
		} catch (error) {
			console.error("Ошибка при обновлении статуса ингредиента:", error);
		}
	};
	const createIngredients = async ({
		nameUa,
		nameEn,
		nameRu,
		noIndgForCategoriesIds = [],
	}) => {
		const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
		const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));

		const refPath = `${
			isDebug ? "debug" : ""
		}/settings/city/${currentCity}/brands/${currentBrand}/productFilters/ingredients`;

		const existingIngredients = ingredients.filter(
			(item) => item !== undefined
		);

		// Проверяем, если первый элемент пустой (""), удаляем его
		if (existingIngredients.length > 0 && !existingIngredients[0].name?.uk) {
			existingIngredients.shift();
		}

		// Создаем новый ингредиент
		const newIngredient = {
			name: {
				uk: nameUa,
				en: nameEn,
				ru: nameRu,
			},
			productsIds:
				noIndgForCategoriesIds.length > 0 ? noIndgForCategoriesIds : [0],
			isActive: false,
		};

		// Добавляем новый ингредиент в конец списка
		const updatedIngredients = [...existingIngredients, newIngredient];

		console.log("updatedIngredients", updatedIngredients);

		// Записываем обновленный массив в Firebase
		firebase.bd
			.ref(refPath)
			.set(updatedIngredients)
			.then(() => {
				console.log("Ингредиент добавлен");
				getData();
			})
			.catch((error) => {
				console.error("Ошибка при добавлении ингредиента:", error);
			});
	};
	useEffect(() => {
		getData();
	}, [brandId]);

	const updateIngredient = async (index, updatedData) => {
		const currentCity = JSON.parse(localStorage.getItem("chosenCity"));
		const currentBrand = JSON.parse(localStorage.getItem("chosenBrand"));
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));

		const prepareData = {
			name: {
				ru: updatedData.nameRu,
				en: updatedData.nameEn,
				uk: updatedData.nameUa,
			},
			productsIds: updatedData.noIndgForCategoriesIds || [""],
		};

		const refPath = `${
			isDebug ? "debug" : ""
		}/settings/city/${currentCity}/brands/${currentBrand}/productFilters/ingredients`;

		const updatedIngredients = [...ingredients];
		updatedIngredients[index] = {
			...updatedIngredients[index],
			...prepareData,
		};

		console.log("updatedIngredients", updatedIngredients);

		firebase.bd
			.ref(refPath)
			.set(updatedIngredients)
			.then(() => {
				console.log("Ингредиент добавлен");
				setIngredients(updatedIngredients);
			})
			.catch((error) => {
				console.error("Ошибка при добавлении ингредиента:", error);
			});
	};

	return (
		<Ingredients
			data={ingredients}
			deleteIngredient={deleteIngredient}
			createIngredients={createIngredients}
			updateIngredient={updateIngredient}
			changeStatus={changeStatus}
		/>
	);
};

export default withFirebase(Container);
